export default __webpack_public_path__ + "static/media/frame_brown_new.f53151ce.png";